<template>
  <v-container fill-height fluid>
    <v-layout class="bg">
      <v-row align="center" justify="center">
        <v-card class="px-4">
          <v-card-text>
            <v-form ref="loginForm" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'eye' : 'eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    hint="At least 8 characters"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6" xsm="12"> </v-col>
                <v-spacer></v-spacer>
                <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                  <v-btn
                    x-large
                    block
                    :disabled="!valid"
                    color="success"
                    @click="validate"
                  >
                    Login
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: true,
    valid: true,

    password: "",
    email: "",
    emailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    show1: false,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
    },
    snackbar: false,
    snackbarText: "",
  }),
  methods: {
    validate() {
      if (this.$refs.loginForm.validate()) {
        this.$sisApi("get", "/sanctum/csrf-cookie").then(() => {
          this.$sisApi("post", `login`, {
            email: this.email,
            password: this.password,
          })
            .then((response) => {
              this.setUser(response);
            })
            .catch((error) => {
              this.snackbar = true;
              this.snackbarText = error.response.data.message;
            });
        });
      }
    },
    setUser(response) {
      if (response.data.id) {
        localStorage.setItem("u", JSON.stringify(response.data));
        this.$store.state.u = response.data;
        this.$router.push("/my-schedule");
      } else {
        this.snackbar = true;
        this.snackbarText = "Login Failed";
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  mounted() {
    this.$sisApi("post", "logout");
    localStorage.removeItem("u");
    this.$store.state.u = {};
  },
};
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: url("../assets/img/intro_background.png") no-repeat center center;
  background-size: cover;
  transform: scale(1.1);
}
</style>
